export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'Home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'Dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'projects',
      displayName: 'Projects',
      meta: {
        icon: 'folder_shared',
      },
    },
    {
      name: 'schedules',
      displayName: 'Schedules',
      meta: {
        icon: 'event_repeat',
      },
    },
    {
      name: 'templates',
      displayName: 'Email Templates',
      meta: {
        icon: 'mail',
      },
    },
    {
      name: 'smtp-profiles',
      displayName: 'SMTP Profiles',
      meta: {
        icon: 'alternate_email',
      },
    },
    {
      name: 'generate',
      displayName: 'Generate Report',
      meta: {
        icon: 'bolt',
      },
    },
    {
      name: 'runs',
      displayName: 'Report Runs',
      meta: {
        icon: 'history',
      },
    },
  ] as INavigationRoute[],
}
